export const firebaseConfig = {
    apiKey: "AIzaSyCRooLMGriAA0HmZie0BPBGswwS_BGtfk8",
    authDomain: "kochibusphotoprod.firebaseapp.com",
    projectId: "kochibusphotoprod",
    storageBucket: "kochibusphotoprod.appspot.com",
    messagingSenderId: "134432611577",
    appId: "1:134432611577:web:8e060696cb0f9fa7971628",
    measurementId: "G-N7FJN1Y6B5"
};
